import React from 'react';
import { Brand } from '@printdeal/ui-library';
import { RelatedProducts } from './RelatedProducts';
import { RelatedSupportArticles } from './RelatedSupportArticles';
import { getConfiguration } from '../../../helpers/Configuration';

export type Message = {
  id: string;
  type?: 'products' | 'faq';
  role: 'user' | 'assistant';
  content: string;
  metadata?: {
    title: string;
    image?: string;
    slug: string;
  }[];
};

export const ChatMessage = ({ message }: { message: Message }) => {
  const { type } = message;
  if (message.role === 'assistant') {
    return (
      <>
        <div className="pd-flex pd-flex-col pd-gap-1">
          <p className="pd-mb-2 pd-text-sm pd-text-dim-500">
            {getConfiguration().channel.name}
          </p>
          <div className="pd-flex pd-items-center pd-gap-4">
            <Brand brand="printdeal-logo-mark" className="pd-min-h-7 pd-min-w-7" />
            <p className="pd-rounded-md pd-bg-dim-100 pd-p-3 pd-text-dim-800">{message.content}</p>
          </div>
        </div>
        {type === 'products' && message.metadata && (<RelatedProducts products={message.metadata} />)}
        {type === 'faq' && message.metadata && (<RelatedSupportArticles articles={message.metadata} />)}
      </>
    );
  }

  return (
    <div className="pd-flex pd-items-center pd-justify-end pd-gap-4">
      <span className="pd-rounded-md pd-bg-tertiary-500 pd-p-3 pd-text-dim-800">{message.content}</span>
    </div>
  );
};
